import { resetForm, loadForm } from '../State/form';
import { setSupplierItem } from '../State/supplierItem';
import axios from '../../../HttpRequests/axios';

export default (props) => async (dispatch) => {

  const { supplierItem } = props;

  if (supplierItem) {
    dispatch(setSupplierItem(supplierItem));

    let inPaintList = false;
    try {
      const settingsResponse = await axios.get('user_settings');
      const paints = (settingsResponse.data && settingsResponse.data.data && settingsResponse.data.data.paints) || [];
      inPaintList = paints.some(p => String(p.catalog_id) === String(supplierItem.id));
    } catch (e) {
      // silently ignore - checkbox will default to false
    }

    const formData = {
      name: supplierItem.name,
      description: supplierItem.description,
      item_code: supplierItem.item_code,
      unit_of_measure: supplierItem.unit_of_measure,
      unit_price: supplierItem.unit_price,
      currency: supplierItem.currency,
      tax_rate: supplierItem.tax_rate,
      lead_time_days: supplierItem.lead_time_days,
      minimum_order_quantity: supplierItem.minimum_order_quantity,
      category: supplierItem.category,
      manufacturer: supplierItem.manufacturer || '',
      add_to_paint_list: inPaintList,
      paint_coats: supplierItem.paint_coats || null,
      paint_coverage_per_litre: supplierItem.paint_coverage_per_litre || null,
      paint_carbon_per_litre: supplierItem.paint_carbon_per_litre || null,
      notes: supplierItem.notes,
      active: supplierItem.active,
      cost_change_reason: '',
    };

    dispatch(loadForm(formData));
  } else {
    dispatch(resetForm());
    dispatch(setSupplierItem(null));
  }
}
